import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get, api_post } from "api/utils"


export type FileUploadTicketType = {
    url: string;
    ticket: string;
}

export type FileType = {
    key: string;
    uuid: string;
    identity: string;
    filename: string;
    disposition: string;
    content_type: string;
    thumb_ticket?: string;
    thumb_width?: number;
    thumb_height?: number;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: FileType) => void;
};

// Domain object File
export class File implements FileType {
    key = "";
    uuid = "";
    identity = "";
    filename = "";
    disposition = "";
    content_type = "";
    thumb_ticket = "";
    thumb_width = 0;
    thumb_height = 0;

    date_created = "";
    date_updated = "";

    constructor(attributes: FileType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: FileType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class FileStore extends BaseStore<FileType, File> {

    async fetchFile(identity: string, association_uuid: string) {
        const params = {identity, association_uuid};
        const response = await api_get('/file/', params);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }

    async fetchFileByUuid(identity: string, uuid: string) {
        const params = {identity, uuid};
        console.log(params);
        const response = await api_get('/file/by-uuid', params);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }


    // async fetchListByIdentityFile(identity_uuid: string, cursor?: CursorType): Promise<FileType[]>  {
    //     // Autogenerated
    //     var url = `/file/by-identity?identity=${identity_uuid}` +
    //         (cursor ? `&cursor=${cursor}` : '');
    //     const response = await api_get(url);
    //     if (response.ok) {
    //         const data = await response.json();
    //         this.receiveUpdate(data.items);
    //         if(data?.cursor) {
    //             this.fetchListByIdentityFile(identity_uuid, data.cursor);
    //         }
    //         // This returns as possibly incomplete list due to the cursor,
    //         // but FileStore.items is complete when .then() is called
    //         // so you can/should just use that.
    //         return data.items;
    //     }
    //     return [];
    // };

    async getUploadTicket(identity: string): Promise<FileUploadTicketType | null> {
        const url = `/file/get-upload-ticket?identity=${identity}`
        const response = await api_get(url);
        if (response.ok) {
            return await response.json() as FileUploadTicketType;
        }
        return null;
    }

    async getDownloadUrl(identity: string, association_uuid: string, disposition: string): Promise<string | null> {
        const url = '/file/get-download-url';
        const params = {identity, association_uuid, disposition};
        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            if(data?.url) return data.url;
        }
        return null;
    }

    async fetchThumbnailUrl(identity: string, association_uuid: string, disposition="inline"): Promise<string | null> {
        const url = '/file/get-thumbnail-url';
        const params = {identity, association_uuid, disposition };
        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            if(data?.url) return data.url;
        }
        return null;
    }


    async fetchThumbnailUrlByOwner(identity: string, uuid: string, disposition="inline"): Promise<string | null> {
        const url = '/file/get-thumbnail-url-by-owner';
        const params = {identity, uuid, disposition};
        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            if(data?.url) return data.url;
        }
        return null;
    }


    async createWithTicket(identity: string,
        ticket: string,
        filename: string,
        mimetype: string,
        disposition="attachment"): Promise<FileType | null> {
        const url = '/file/create-with-ticket';
        const data = {
            identity: identity,
            ticket: ticket,
            filename: filename,
            disposition: disposition,
            content_type: mimetype || "application/octet-stream"
        };
        const response = await api_post(url, data);
        if (response.ok) {
            return await response.json() as FileType;
        }
        return null;
        }

    modelConstructor() {
        return File;
    }

}
